import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Deck } from '@deckplan.io/common/decks';
import { Router } from '@angular/router';
import { DecksService, DecksWithTotalCount } from '../decks.service';
import { ContextMenuComponent } from '../../common/context-menu/context-menu.component';
import { Pagination, Query } from '@deckplan.io/common';
import { Utils } from '../common/utils';
import { PageEvent } from '@angular/material/paginator';
import { EditableDataField } from '../../common/filter/editable-data-field';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-deck-list',
    templateUrl: './deck-list.component.html',
    styleUrls: ['./deck-list.component.scss']
})
export class DeckListComponent implements OnInit {

    @Input() public deckObservable: Observable<Deck[]>;

    @Output() public deckClicked = new EventEmitter<Deck>();

    public decksWithTotalCount: DecksWithTotalCount;

    public isLoadingResults = true;

    public asc = true;

    // eslint-disable-next-line no-magic-numbers
    public pageSizeOptions = [5, 10, 50, 100];
    public defaultPageIndex = 0;
    // eslint-disable-next-line no-magic-numbers
    public defaultPageSize = 10;

    public searchColumns: EditableDataField[] = [
        {dataType: 'string', field: 'name', title: 'Deck Name', isInput: false},
        {dataType: 'string', field: 'format', title: 'Deck Format', isInput: false},
        {dataType: 'string', field: 'alias', title: 'Deck Owner', objectType: 'user', isInput: false},
        {dataType: 'color', field: 'colorIdentity', title: 'Deck Color', objectType: 'card', isInput: false},
        {dataType: 'string', field: 'name', title: 'Card Name', objectType: 'card', isInput: false},
        {dataType: 'string', field: 'setName', title: 'Card Set', objectType: 'card', isInput: false},
        {dataType: 'color', field: 'specialData', title: 'Commander Color', isInput: false}
    ] as any;

    public sortFieldCtl = new FormControl({field: 'name', title: 'Deck Name', dataType: 'string', isInput: false});

    private query: Query;
    private readonly page: Pagination = {
        page: {pageIndex: 0, pageSize: 10},
        sort: {active: 'deck.name', direction: 'asc'}
    };

    @ViewChild(ContextMenuComponent, {static: false}) private readonly contextMenu: ContextMenuComponent;

    constructor(private readonly decksService: DecksService,
                private readonly router: Router) {}

    public ngOnInit() {
        this.loadDecks();
        this.sortFieldCtl.valueChanges.subscribe(field => {
            const active = field.objectType ? `${field.objectType}.${field.field}` : `deck.${field.field}`;
            this.sortByField(active);
        });
    }

    public newQuery(query: Query) {
        this.query = Utils.AddInventoryCardFields(query);
        this.loadDecks();
    }

    public newPage(pageEvent: PageEvent) {
        this.page.page = {pageIndex: pageEvent.pageIndex, pageSize: pageEvent.pageSize};
        this.loadDecks();
    }

    private loadDecks() {
        this.decksService.getAll(this.query, this.page).subscribe(decksWithTotalCount => {
            this.decksWithTotalCount = decksWithTotalCount;
            this.isLoadingResults = false;
        });
    }

    public onDeckClicked(deck: any) {
        this.deckClicked.emit(deck);
        this.router.navigate([`decks/${deck.id}`]);
    }

    public addDeck() {
        this.decksService.create({name: 'New Deck', format: 'Freeform'}).subscribe(deck => this.onDeckClicked(deck));
    }

    public sortByField(field: string) {
        this.page.sort.active = field;
        this.loadDecks();
    }

    public toggleDirection() {
        this.asc = !this.asc;
        this.page.sort.direction = this.asc ? 'asc' : 'desc';
        this.loadDecks();
    }

    public deleteDeck(deck: Deck) {
        this.decksService.delete(deck.id)
            .subscribe(() => this.loadDecks());
    }

}
